import { InfoIcon } from '@mm/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Heading } from '@mm/components';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import { NeedHelpLabel } from '../../../../common/components/NeedHelpLabel/NeedHelpLabel';
import { AwaySetings } from './AwaySettings/AwaySettings';
import './BusinessHours.pcss';
import { TimezoneAndWeekDayPicker } from './TimezoneAndWeekDayPicker/TimezoneAndWeekDayPicker';

export const BusinessHours = () => {
  const activeChatbot = useSelector(activeChatbotSelector);

  return activeChatbot ? (
    <>
      <div className="business-hours-settings">
        <div className="business-hours-settings__heading">
          <Heading size={3} text="Business Hours" />
          <NeedHelpLabel
            link="https://customers.ai/help/article/mv7bg0mmby-business-hours"
            iconOnly
          />
        </div>
        <div className="business-hours-settings__info-message">
          <InfoIcon className="business-hours-settings__info-icon" />
          <span>Set hours of operations for your business</span>
        </div>
        <TimezoneAndWeekDayPicker />
      </div>
      <AwaySetings />
    </>
  ) : null;
};
